import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import {NotificationActionTypes, successNotify,} from '../../factory/createNotification'
import {
    organization_createTimetable_Api,
    organization_deleteTimetable_Api,
    organization_updateTimetable_Api
} from "../../../../apis";
import {NullAsDefault} from "../../../Shared";
import {notifyOnError} from "../../factory/createErrorEvent";

const useOrganizationTimetableApi = ({
                                         notifyListeners = {
                                             onRefresh: undefined,
                                             onCancel: undefined
                                         },
                                     }) => {
    const t = useTranslate()

    const {
        onRefresh = NullAsDefault,
        onCancel = NullAsDefault
    } = notifyListeners ?? {}

    const onError = notifyOnError(t)

    const {handleAsyncAction: createTimetable} = useAsyncAction({
        apiInfo: organization_createTimetable_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.CREATE, t)
            onRefresh()
        },
    })

    const {handleAsyncAction: updateTimetable} = useAsyncAction({
        apiInfo: organization_updateTimetable_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onCancel()
        },
    })

    const {handleAsyncAction: deleteTimetable} = useAsyncAction({
        apiInfo: organization_deleteTimetable_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.DELETE, t)
            onRefresh()
        },
    })


    return {
        createTimetable,
        updateTimetable,
        deleteTimetable
    }
}

export default useOrganizationTimetableApi
